import { FilterCompanyDocumentsWebPage, getCompanyDocumentsWebPage } from 'commons/service/bank/companyDetails'
import { CompanyDocumentsWebPage } from 'commons/types/DTO/bank/companyDetails/document'
import { WriteHook, useMutationManager } from 'state-manager'

export const useFilterCompanyDocumentsWebPage: WriteHook<FilterCompanyDocumentsWebPage, CompanyDocumentsWebPage> = (
  opts
) => useMutationManager(getCompanyDocumentsWebPage, opts)
